import { createSlice } from '@reduxjs/toolkit';

const initialState = [];

const haveLoadedInstance = (state, instance) =>
  state.some((item) => item.storedDocumentId === instance.storedDocumentId);

export const documentsSlice = createSlice({
  name: 'documents',
  initialState: initialState,
  reducers: {
    clearDocuments: () => {
      return initialState;
    },

    addDocuments: (state, action) => {
      const documents = action.payload;
      const newDocs = documents.filter((d) => !haveLoadedInstance(state, d));
      return [...state, ...newDocs];
    },

    updateDocument: (state, action) => {
      const instance = action.payload;
      const filteredList = state.filter((d) => d.storedDocumentId !== instance.storedDocumentId);
      return filteredList.concat(instance);
    },

    deleteDocument: (state, action) => {
      return state.filter((d) => d.storedDocumentId !== action.payload);
    },
  },
});

export const { clearDocuments, addDocuments, updateDocument, deleteDocument } = documentsSlice.actions;

export default documentsSlice.reducer;
